import { useDispatch, useSelector } from 'react-redux';

import {
  getContentDetails,
  setContentDetailsAction,
  clearContentDetailsAction,
  setContentsListAction,
  clearContentsListAction,
} from 'features/contents/redux/slice';

import { UseContentsState, ContentDetailsApiResponse } from './types';
import { ContentsItem } from '.';

const useMenu = (): UseContentsState => {
  const dispatch = useDispatch();

  const { contentsList, contentDetails } = useSelector(getContentDetails);

  const setContentDetails = (receivedContent: ContentDetailsApiResponse) => {
    dispatch(setContentDetailsAction(receivedContent));
  };

  const clearContentDetails = () => {
    dispatch(clearContentDetailsAction());
  };

  const setContentsList = (receivedContents: ContentsItem[]) => {
    dispatch(setContentsListAction(receivedContents));
  };

  const clearContentsList = () => {
    dispatch(clearContentsListAction());
  };

  return {
    contentsList,
    setContentsList,
    clearContentsList,

    contentDetails,
    setContentDetails,
    clearContentDetails,
  };
};

export default useMenu;
